import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pbg-liars-dice-rules',
  templateUrl: './liars-dice-rules.component.html',
  styleUrls: ['./liars-dice-rules.component.scss']
})
export class LiarsDiceRulesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
